function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import SignupButtonDefaultProps from "segments/desktop/core-components/button/signup-button/default-props";
import YoutubePopupButtonDefaultProps from "segments/desktop/core-components/button/youtube-popup-button/default-props";
export default {
    signupButtonConfig: _object_spread({}, SignupButtonDefaultProps),
    youtubePopupButtonConfig: _object_spread({}, YoutubePopupButtonDefaultProps)
};
